import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { localize } from '../../i18n';

const typeToBadge = {
  log: 'notification',
  error: 'danger',
};

const typeToText = {
  log: 'info',
  error: 'error',
};

const LogItem = ({ type, args }) => (<li>
  <div className={`uk-badge uk-badge-${typeToBadge[type]}`}>{typeToText[type]}</div> &nbsp;
  <span>{args.join(' ')}</span>
</li>);

LogItem.propTypes = {
  type: PropTypes.string,
  args: PropTypes.arrayOf(PropTypes.any),
};

const Logging = props =>
  (props.logs.length ?
    (<ul className="uk-list uk-list-striped">
      {props.logs.map((log, index) => <LogItem key={index} {...log} />)}
    </ul>) :
    (<div className="uk-alert">{props.t('No Logs')}.</div>));

Logging.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      args: PropTypes.arrayOf(PropTypes.any),
    }),
  ),
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ nativeLogging }) => {
  console.log(nativeLogging);
  return { logs: nativeLogging.logs };
};

export default localize(connect(mapStateToProps)(Logging));



// WEBPACK FOOTER //
// ./src/views/logging/Logging.js